import { DirectiveOptions } from 'vue';
import { getUrlTarget, getRel } from '@/shared/services/link-service';

const directive: DirectiveOptions = {
    bind(el, binding, node) {
        var links: NodeListOf<HTMLAnchorElement> = el.querySelectorAll('a');

        links.forEach((link: HTMLAnchorElement) => {
            link.setAttribute("target", getUrlTarget(link.href));
            link.setAttribute("rel", getRel(link.href));
        });
    }
};

export default directive;